import { z } from 'zod';

export type AuthOrigin = 'local' | 'global';

export const authOriginSchema = z.enum(['local', 'global']);

/**
 * Retrieves and validates the `auth_origin` parameter from the URL.
 * Adds a derived `isGlobal` boolean for convenience.
 */
export const getAuthOriginFromUrl = (): {
  origin: AuthOrigin | null;
  isGlobal: boolean;
  isLocal: boolean;
} => {
  const searchParams = new URLSearchParams(globalThis.window.location.search);
  const origin = searchParams.get('auth_origin');

  const isValid = !!origin && authOriginSchema.safeParse(origin).success;
  const isGlobal = isValid && origin === 'global';
  const isLocal = isValid && origin === 'local';

  return {
    origin: isValid ? (origin as AuthOrigin) : null,
    isGlobal,
    isLocal,
  };
};
